// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  "version": "1.7.0"
};
/* tslint:enable */



// WEBPACK FOOTER //
// ./src/environments/version.ts